import commonActions from "../common/actions";
import examActions from "./actions";
import axios from "axios";
import { takeEvery, call, all, put, delay } from "redux-saga/effects";
import { API_URL } from "../../utils/constants";
import {
  handleDecodeJSON,
  handleEncodeJson,
} from "../../utils/encodeDecodeJson";
import Cookies from "js-cookie";
import { EncryptObjectFunction } from "../../utils/cryptoFunction";
import { formatDate, formatTime } from "../../utils/commonFunctions";

const examSagas = function* () {
  yield all([
    yield takeEvery(examActions.GET_PROJECT_DETAILS, getProjectDetails),
    yield takeEvery(examActions.GET_HEART_BEAT, heartBeat),
    yield takeEvery(examActions.GET_INSTRUCTIONS, getInstructions),
    yield takeEvery(examActions.GET_EXAM_QUESTIONS, getQuestions),
    yield takeEvery(examActions.GET_SUBMIT_ANSWER, submitAndGetQuestion),
    yield takeEvery(examActions.AUDIT_LOG, auditLog),
    yield takeEvery(examActions.END_EXAM, endExam),
    yield takeEvery(examActions.ACTIVE_PING, activePing),
    yield takeEvery(examActions.GET_CANDIDATE_SCORE, getCandidateScore),
    yield takeEvery(examActions.GET_EXAM_EVENTS, getExamEvents), /// Broadcast events////
    yield takeEvery(examActions.GET_EXAM_SCHEDULE,getExamSchedule), /// candidate profile creation///////
    yield takeEvery(examActions.INLINE_UPLOAD_FILE, inlineUploadFile),
    yield takeEvery(examActions.INLINE_DELETE_FILE, inlineDeleteFile),
  ]);
};

const getCandidateScoreAPI = () => {
  return axios.get(`${API_URL}/api/exam/candidate-score`);
};

const getCandidateScore = function* (action) {
  console.log("Score saga triggered");
  try {
    yield put({
      type: examActions.SET_CANDIDATE_SCORE_LOADING,
      payload: true,
    });

    const response = yield call(getCandidateScoreAPI);

    const decodedResult = yield call(() =>
      handleDecodeJSON({ decodeJSON: response?.data?.data })
    );

    yield put({
      type: examActions.SET_CANDIDATE_SCORE,
      payload: decodedResult,
    });
  } catch (error) {
    console.log("Score API Error:", error);
    yield put({
      type: examActions.SET_CANDIDATE_SCORE_ERROR,
      payload: error?.response?.data?.message || "Failed to fetch score",
    });
  } finally {
    yield put({
      type: examActions.SET_CANDIDATE_SCORE_LOADING,
      payload: false,
    });
  }
};


////////////// Candidate Profile Creation ////////////////
const fetchExamScheduleAPI = () => {
  return axios.get(`${API_URL}/api/exam/get-candidate-exams`);
};


const getExamSchedule = function* () {
  try {
    const result = yield call(fetchExamScheduleAPI);

    // decode  encrypted payload
    const decoded = yield call(() =>
      handleDecodeJSON({ decodeJSON: result?.data?.data})
    );
     const exams = decoded?.exams ?? []; 
    yield put({
      type: examActions.SET_EXAM_SCHEDULE,
      payload: Array.isArray(exams) ? exams : []
    });

  } catch (err) {
    console.error("Exam Schedule API Error:", err);
  }
};


////////////// End Of Creation ///////////////////////////

////////////// Broadcast events///////////////////
// / ========= API CALL =========
const getExamBroadcasts = () => {
  return axios.get(`${API_URL}/api/exam/broadcasts`);
}


// ========= WORKER SAGA =========
const fetchExamEvents = function* () {
  try {
    console.log("Fetching broadcast events...");
    const response = yield call(getExamBroadcasts);
    // const apiData = response?.data?.data || [];
    const decodedResult = yield call(() =>
      handleDecodeJSON({ decodeJSON: response?.data?.data })
    );
    console.log("Broadcast events fetched:", decodedResult);


    yield put({
      type: examActions.SET_EXAM_EVENTS,
      payload: decodedResult,


    });

  } catch (error) {
    console.log("Broadcast API Error:", error);
  }
}
const getExamEvents = function* () {
  yield call(fetchExamEvents);
}
//////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////////////
const getProjectDetails = function* (data) {
  const { payload } = data;
  const { navigate, url } = payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    let result = null;
    if (
      // payload?.data?.project != "undefined" &&
      payload?.data?.project != "venue"
    ) {
      result = yield call(() =>
        axios.get(
          `${API_URL}/api/exam/project-details/${payload?.data?.project}`
        )
      );
    } else {
      result = yield call(() =>
        axios.get(`${url || API_URL}/api/exam/project-details`)
      );
      sessionStorage.setItem("venue", true);
      Cookies.set("test_engine_project", "venue", { expires: 7 });
    }

    yield put({
      type: examActions.SET_PROJECT_DETAILS,
      payload: result?.data?.code === "OK" ? result?.data?.data : [],
    });
  } catch (err) {
    if (err?.response?.data?.code === "E_NOT_FOUND") {
      navigate("/project-not-found");
    }
    console.log(err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const heartBeat = function* () {
  try {
    const result = yield call(() => axios.get(`${API_URL}/api/exam/heartbeat`));
    yield put({
      type: examActions.SET_HEART_BEAT,
      payload:
        result?.data?.code === "OK"
          ? {
            ...result?.data,
            formattedTime: formatTime(result?.data?.data),
            formattedDate: formatDate(result?.data?.data),
          }
          : [],
    });
  } catch (err) {
    console.log(err);
  }
};

const getInstructions = function* () {
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/api/exam/instructions`)
    );
    const decodedResult = yield call(() =>
      handleDecodeJSON({ decodeJSON: result?.data?.data })
    );
    yield put({
      type: examActions.SET_INSTRUCTIONS,
      payload: result?.data?.code === "OK" ? decodedResult : [],
    });
  } catch (err) {
    console.log(err);
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getQuestions = function* (data) {
  const { payload } = data;
  const { navigate, mockMode, summary } = payload;
  try {
    let result;
    if (mockMode) {
      result = yield call(() =>
        axios.post(`${API_URL}/api/exam/start-mock-exam`, payload.data)
      );
    } else {
      result = yield call(() =>
        axios.post(`${API_URL}/api/exam/start-exam`, payload.data)
      );
    }

    const decodedResult = yield call(() =>
      handleDecodeJSON({ decodeJSON: result?.data?.data })
    );
    yield put({
      type: examActions.SET_EXAM_QUESTIONS,
      payload: result?.data?.code === "OK" ? decodedResult : [],
    });
    if (result?.data?.code === "OK") {
      const queryParams = {
        SrNo: decodedResult?.questionData?.srNo,
        lang: `${payload?.formData?.language}`,
        img: `${payload?.formData?.imageSize}`,
      };
      const encryptedParans = EncryptObjectFunction(queryParams);

      if (mockMode) {
        navigate(`/mock-test?qNo=${encryptedParans}`);
      } else {
        localStorage.setItem("examEndTime", decodedResult?.examEndTime);
        window.dispatchEvent(new Event("storageUpdate"));
        const currenntSection = decodedResult?.questionData?.sectionName;
        const encodedData = JSON.parse(
          sessionStorage.getItem("candidate_exam_details")
        );
        const decodedData = yield call(() =>
          handleDecodeJSON({ decodeJSON: encodedData })
        );

        function convertHHMMtoMinutes(timeStr) {
          const [hours, minutes] = timeStr.split(":").map(Number);
          return hours * 60 + minutes;
        }
        const totalDuration = yield call(
          () => decodedData?.configuration?.timeDuration
        );
        const totalMinutes = convertHHMMtoMinutes(totalDuration);
        function* adjustSectionTimes(
          sections,
          remainingMinutes,
          currentSectionTitle,
          sectionNavigation = decodedData?.configuration?.sectionNavigation
        ) {
          if (sectionNavigation === "MOVEMENT_RESTRICTION_WITH_NO_TIME") {
            const updatedSections = sections.map((section) => ({
              ...section,
              sectionTime: "00:00",
            }));
            decodedData.configuration.sections = updatedSections;
            const updatedEncodedData = yield call(() =>
              handleEncodeJson({ encodeJSON: decodedData })
            );
            sessionStorage.setItem(
              "candidate_exam_details",
              JSON.stringify(updatedEncodedData)
            );
            return updatedSections;
          } else if (sectionNavigation === "MOVEMENT_RESTRICTION_WITH_INCREMENTAL_TIME") {
            const currentIndex = sections.findIndex(
              (section) => section.sectionTitle === currentSectionTitle
            );

            if (currentIndex === 1) {
              const prevTime = sections[0]?.sectionTime || "00:00";
              const currentTime = sections[1]?.sectionTime || "00:00";

              const [prevMins, prevSecs] = prevTime.split(":").map(Number);
              const [currentMins, currentSecs] = currentTime
                .split(":")
                .map(Number);

              const totalSecs =
                (prevMins + currentMins) * 60 + (prevSecs + currentSecs);

              const newMins = Math.floor(totalSecs / 60);
              const newSecs = totalSecs % 60;

              return sections.map((section, index) => {
                if (index === 0) {
                  return { ...section, sectionTime: "00:00" };
                } else if (index === 1) {
                  return {
                    ...section,
                    sectionTime: `${String(newMins).padStart(2, "0")}:${String(
                      newSecs
                    ).padStart(2, "0")}`,
                  };
                } else {
                  return section;
                }
              });
            }

            if (currentIndex <= 1) return sections;

            const prevIndex = currentIndex - 1;
            const prevTime = sections[prevIndex].sectionTime;
            const currentTime = sections[currentIndex].sectionTime;

            const [prevMins, prevSecs] = prevTime.split(":").map(Number);
            const [currentMins, currentSecs] = currentTime
              .split(":")
              .map(Number);

            const prevTotalSecs = prevMins * 60 + prevSecs;
            const currentTotalSecs = currentMins * 60 + currentSecs;

            return sections.map((section, index) => {
              const [mins, secs] = section.sectionTime.split(":").map(Number);
              let totalSecs = mins * 60 + secs;

              if (index === prevIndex) {
                totalSecs = 0;
              } else if (index === currentIndex) {
                totalSecs = remainingMinutes * 60;
              } else if (index > currentIndex) {
                totalSecs =
                  remainingMinutes * 60 + (totalSecs - currentTotalSecs);
              }

              const newMins = Math.floor(totalSecs / 60);
              const newSecs = totalSecs % 60;

              return {
                ...section,
                sectionTime: `${String(newMins).padStart(2, "0")}:${String(
                  newSecs
                ).padStart(2, "0")}`,
              };
            });
          }
        }

        const sectionNavigation = yield call(() => decodedData?.configuration?.sectionNavigation)
        if (
          sectionNavigation === "MOVEMENT_RESTRICTION_WITH_INCREMENTAL_TIME"
        ) {
          const updatedSections = yield call(adjustSectionTimes,
            decodedData?.configuration?.sections,
            totalMinutes,
            currenntSection
          );

          decodedData.configuration.sections = updatedSections;

          const updatedEncodedData = yield call(() =>
            handleEncodeJson({ encodeJSON: decodedData })
          );
          sessionStorage.setItem(
            "candidate_exam_details",
            JSON.stringify(updatedEncodedData)
          );
        }

        navigate(
          `/${Cookies.get(
            "test_engine_project"
          )}/live-test?qNo=${encryptedParans}`
        );
      }
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.code === "OK" ? "success" : null,
          show: true,
          message: summary ? "Exam Resumed" : "Exam Started",
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
  } catch (err) {
    console.log(err);
  }
};

const submitAndGetQuestion = function* (data) {
  const { payload } = data;
  const { navigate, handleSelectedValue, mockMode, radio } = payload;
  try {
    let result;
    if (mockMode) {
      result = yield call(() =>
        axios.post(`${API_URL}/api/exam/submit-mock-answer`, payload.data)
      );
    } else {
      result = yield call(() =>
        axios.post(`${API_URL}/api/exam/submit-answer`, payload.data)
      );
    }

    const decodedResult = yield call(() =>
      handleDecodeJSON({ decodeJSON: result?.data?.data })
    );

    yield put({
      type: examActions.SET_EXAM_QUESTIONS,
      payload: result?.data?.code === "OK" ? decodedResult : [],
    });

    if (result?.data?.code === "OK") {
      if (navigate) {
        if (mockMode) {
          navigate(`/mock-test`);
        } else {
          navigate(`/${Cookies.get("test_engine_project")}/live-test`);
        }
      }
      if (!radio && typeof handleSelectedValue === 'function') {
        handleSelectedValue("");
      }
    }
  } catch (err) {
    console.log(err);
    if (err?.response?.data?.code === "SECTION_TIME_NOT_STARTED") {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message:
            err?.response?.data?.code === "SECTION_TIME_NOT_STARTED" &&
            "Question is available only after section time started",
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: { status: null, show: false, message: null },
      });
      let visitedQuestions =
        JSON.parse(sessionStorage.getItem("visitedQuestions")) || [];

      if (visitedQuestions.length > 0) {
        visitedQuestions.pop();
      }

      sessionStorage.setItem(
        "visitedQuestions",
        JSON.stringify(visitedQuestions)
      );
    }
  }
};

const auditLog = function* (data) {
  const { payload } = data;
  try {
    const encodeData = yield call(() =>
      handleEncodeJson({ encodeJSON: payload?.data })
    );
    const result = yield call(() =>
      axios.post(`${API_URL}/api/exam/question-audit-log`, encodeData)
    );
  } catch (err) {
    console.log(err);
  }
};

const endExam = function* (data) {
  const { payload } = data;
  try {
    let result;
    if (payload?.mockMode) {
      result = yield call(() =>
        axios.post(`${API_URL}/api/exam/end-mock-exam`)
      );
    } else {
      result = yield call(() => axios.post(`${API_URL}/api/exam/end-exam`));
    }
    // if (result?.data?.code === "OK") {
    //   sessionStorage.removeItem("candidate_exam_details");
    //   localStorage.removeItem("updatedQuestionsList");
    // }
  } catch (err) {
    console.log(err);
  }
};

const activePing = function* (data) {
  const { payload } = data;
  // const { lastApiCallTime } = payload;
  try {
    yield call(() =>
      axios.post(`${API_URL}/api/exam/active-ping`, payload?.data)
    );
    // lastApiCallTime.current = Date.now();
  } catch (err) {
    console.log(err);
  }
};

// ── Inline descriptive upload sagas ──────────────────────────────────────────
const inlineUploadFile = function* (data) {
  const { payload } = data;
  const { file, srNo, onSuccess, onError } = payload;
  try {
    const encodedPayload = yield call(() =>
      handleEncodeJson({ encodeJSON: { srNo } })
    );

    const formData = new FormData();
    formData.append("file", file);
    Object.entries(encodedPayload).forEach(([key, val]) => {
      formData.append(key, val);
    });

    const result = yield call(() =>
      axios.post(
        `${API_URL}/api/exam/descriptive-upload/inline-exam/upload`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
    );

    if (result?.data?.code !== "OK") {
      const err = new Error(result?.data?.message || "Upload failed");
      err.code = result?.data?.code;
      throw err;
    }

    const decodedResult = yield call(() =>
      handleDecodeJSON({ decodeJSON: result?.data?.data })
    );

    const fileUrl =
      decodedResult?.descriptiveUploadAnsUrl ?? decodedResult?.filePath ?? null;

    if (typeof onSuccess === "function") onSuccess(fileUrl);
  } catch (err) {
    const msg =
      err?.response?.data?.message ?? err?.message ?? "Upload failed. Please retry.";
    if (typeof onError === "function") onError(msg);
  }
};

const inlineDeleteFile = function* (data) {
  const { payload } = data;
  const { srNo, onSuccess, onError } = payload;
  try {
    const encodedBody = yield call(() =>
      handleEncodeJson({ encodeJSON: { srNo } })
    );
    yield call(() =>
      axios.post(
        `${API_URL}/api/exam/descriptive-upload/inline-exam/delete`,
        encodedBody
      )
    );
    if (typeof onSuccess === "function") onSuccess();
  } catch (err) {
    console.log("Inline delete error:", err);
    if (typeof onError === "function") onError();
  }
};

export default examSagas;
